let patched = false;

type DomParentMismatch = {
  operation: 'removeChild' | 'insertBefore';
  parentNodeName: string;
  childNodeName: string;
};

// Browser translation can reparent text nodes after React records their parent.
export function patchDomNodeRemoval(onMismatch?: (details: DomParentMismatch) => void) {
  if (patched || typeof window === 'undefined' || typeof Node === 'undefined') return;
  patched = true;
  let reported = false;

  function report(operation: DomParentMismatch['operation'], parent: Node, child: Node) {
    if (reported) return;
    reported = true;
    try {
      onMismatch?.({ operation, parentNodeName: parent.nodeName, childNodeName: child.nodeName });
    } catch {
      // Telemetry must not interrupt React's DOM commit.
    }
  }

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      const actualParent = child.parentNode;
      if (actualParent) originalRemoveChild.call(actualParent, child);
      report('removeChild', this, child);
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore<T extends Node>(
    this: Node,
    node: T,
    child: Node | null,
  ): T {
    if (child && child.parentNode !== this) {
      let reference: Node | null = child;
      while (reference && reference.parentNode !== this) reference = reference.parentNode;
      const inserted = originalInsertBefore.call(this, node, reference) as T;
      report('insertBefore', this, child);
      return inserted;
    }
    return originalInsertBefore.call(this, node, child) as T;
  };
}
